import type { Game } from '../../game/Game';
import { registerPanel } from '../../ui/app/App';
import { setGame } from '../economy/ui';
import './settings.css';
import { SettingsPanel } from './SettingsPanel';

export { fullBindings, rebind } from './keybinds';

/** Settings (`settings` panel, Esc): video, audio, gameplay, keybinds, account. */
export function install(game: Game): void {
  setGame(game);
  registerPanel('settings', SettingsPanel);
}
